import type { ReactNode } from 'react'
import ClientTabStatusContexts from './ClientTabStatusContexts'

interface ClientTabStatusProviderProps {
  enabled: boolean
  children: ReactNode
}

const ClientTabStatusProvider = ({ enabled, children }: ClientTabStatusProviderProps) => {
  if (!enabled) return <>{children}</>

  return <ClientTabStatusContexts>{children}</ClientTabStatusContexts>
}

export default ClientTabStatusProvider
